import React, { useState, useEffect, useCallback } from "react";

//========================================================================
// Array auflösen
const readArray = (array, index) => {
  index = Math.abs(parseInt(index)) || 0;

  let maxIndex = 0;
  let arrayIntern = [];
  let value;
  try {
    if (array === null) {
      arrayIntern = [0];
    } else {
      arrayIntern = JSON.parse(array);
    }
  } catch (error) {
    arrayIntern = [0];
  }

  maxIndex = arrayIntern.length;
  if (index >= maxIndex) {
    index = maxIndex - 1;
  }
  value = arrayIntern[index].toString();

  return value;
};

const writeArray = (array, index, value, baseType) => {
  index = Math.abs(parseInt(index)) || 0;
  let maxIndex = 0;
  let arrayIntern = [];
  try {
    if (array === null) {
      arrayIntern = [0];
    } else {
      arrayIntern = JSON.parse(array);
    }
  } catch (error) {
    arrayIntern = [0];
  }

  maxIndex = arrayIntern.length;
  if (index >= maxIndex) {
    index = maxIndex - 1;
  }

  if (baseType === "INT") {
    arrayIntern[index] = parseInt(value);
  } else if (baseType === "REAL") {
    arrayIntern[index] = parseFloat(value);
  }
  return JSON.stringify(arrayIntern);
};

//========================================================================
// Bit aus Integer extrahieren
const readBit = (value, bitIndex, type) => {
  let bitVal = 0;
  bitIndex = Math.abs(parseInt(bitIndex)) || 0;
  let maxBitIndex = 0;

  if (type === "INT" || type === "UINT" || type === "WORD") {
    maxBitIndex = 15;
  } else if (type === "DINT" || type === "UDINT" || type === "DWORD") {
    maxBitIndex = 31;
  }
  if (bitIndex > maxBitIndex) {
    bitIndex = maxBitIndex;
  }

  let word;
  try {
    word = parseInt(value)
      .toString(2)
      .padStart(maxBitIndex + 1, "0")
      .split("")
      .reverse()
      .join("");
  } catch (error) {
    word = 0;
  }

  try {
    bitVal = word[bitIndex];
  } catch (error) {}

  return bitVal;
};

const writeBit = (value, bitIndex, bitValue, type) => {
  bitIndex = Math.abs(parseInt(bitIndex)) || 0;
  let maxBitIndex = 0;
  let newValue = value;

  if (type === "INT" || type === "UINT" || type === "WORD") {
    maxBitIndex = 15;
  } else if (type === "DINT" || type === "UDINT" || type === "DWORD") {
    maxBitIndex = 31;
  }
  if (bitIndex > maxBitIndex) {
    bitIndex = maxBitIndex;
  }

  let word;
  try {
    word = parseInt(value)
      .toString(2)
      .padStart(maxBitIndex + 1, "0")
      .split("")
      // .reverse()
      .join("");
  } catch (error) {
    word = 0;
  }

  let wordArray = word.split("");

  try {
    if (bitValue === "1") {
      wordArray[maxBitIndex - bitIndex] = "1";
    } else {
      wordArray[maxBitIndex - bitIndex] = "0";
    }
    newValue = wordArray.join("");
  } catch (error) {
    console.error("Fehler beim Schreiben des Bits:", error);
  }

  // console.log("val", parseInt(newValue, 2).toString());
  return parseInt(newValue, 2).toString();
};

//========================================================================
// Funktionen exportieren
export { readArray, writeArray, readBit, writeBit };
